module.exports = __webpack_public_path__ + "img/mission.571e873a.png";